import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import PrivacyNoticeLink from '../common/PrivacyNoticeLink';

const drawerWidth = 240;
const drawerWidthCollapsed = 64;

const Layout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [desktopOpen, setDesktopOpen] = useState<boolean>(true);

  const handleDrawerToggle = (): void => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopToggle = (): void => {
    setDesktopOpen(!desktopOpen);
  };

  const currentDrawerWidth = desktopOpen ? drawerWidth : drawerWidthCollapsed;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Barra de navegación superior */}
      <Navbar 
        onDrawerToggle={handleDrawerToggle}
        onDesktopToggle={handleDesktopToggle}
        desktopOpen={desktopOpen}
        drawerWidth={currentDrawerWidth}
      />
      
      {/* Barra lateral */}
      <Sidebar 
        open={mobileOpen} 
        onClose={handleDrawerToggle}
        desktopOpen={desktopOpen}
      />
      
      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden',
          width: { sm: `calc(100% - ${currentDrawerWidth}px)` },
          backgroundColor: 'background.default',
          transition: (theme) => theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar /> {/* Espaciador para la navbar fija */}
        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', width: '100%', p: 3 }}>
          <Outlet />
        </Box>
        <Box
          component="footer"
          sx={{
            px: 3,
            py: 1,
            borderTop: 1,
            borderColor: 'divider',
            bgcolor: 'background.paper',
            textAlign: 'right'
          }}
        >
          <PrivacyNoticeLink />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;